import Vue from 'vue'
// import './style/theme/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import NProgress from 'nprogress'

// import 'element-ui/lib/theme-default/index.css'
import './style/style.scss'
import App from './App.vue'
import router from './config/routes'
import store from './store'

import Api from './common/api'
import ApiOuter from './common/apiOuter'
import ApiJava from './common/apiJava'
import apiUrl from './common/apiUrl'
import Validator from './common/validator'
import Utils from './common/utils'
Vue.use(ElementUI)

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
    key: 'b68c04faea9a02c6db4aa8ac6141a1cc',
    // 插件集合
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
});

//绑定到Vue上
Vue.prototype.$api = Api
Vue.prototype.$apiOuter = ApiOuter
Vue.prototype.$apiJava = ApiJava
Vue.prototype.$apiUrl = apiUrl
Vue.prototype.$valid = Validator
Vue.prototype.$utils = Utils

const whiteList = ['/passport/login'];
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (store.getters.userId && store.getters.userId.length>0) {
        if (to.path === '/passport/login') {
            next({path: '/'});
        } else {
            next();
            //权限判断
            if(to.params.ruleId){
                let ruleId = to.params.ruleId;
                let menus = JSON.parse(localStorage.getItem('menus')).children;
                for(let m of menus){
                    if(m.rule_id == ruleId && m.children){
                        store.commit('SET_OPERATION',m.children);
                        break;
                    }
                    if(m.children){
                        for(let m1 of m.children) {
                            if (m1.rule_id == ruleId && m1.children) {
                                store.commit('SET_OPERATION', m1.children);
                                break;
                            }
                        }
                    }
                }
            }else{
                next();
            }
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next({path: '/passport/login'});
            NProgress.done();
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./vue/main.js